import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible'
// import lottie from "vue-lottie";
import Vant from 'vant';
import 'vant/lib/index.css';
import Axios from 'axios'
import { Toast } from 'vant';
import  {VueJsonp}  from  'vue-jsonp'
Axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
// Axios1.defaults.baseURL = process.env.VUE_APP_VOTE_URL

Vue.prototype.$api = Axios
// Vue.prototype.$api2 = Axios1
Vue.prototype.$toast = Toast
Vue.prototype.$deviceType = function () {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  return isAndroid ? 'Android' :"IOS" ;
}()
Vue.prototype.$isCyolapp = function () {
  let u = navigator.userAgent;
  return u.includes('CYOLAPP')
}()

Vue.use(VueJsonp);
Vue.use(Vant);
Vue.config.productionTip = false
// Vue.component("lottie", lottie);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
